import React from "react";
import { User } from "lucide-react";

export function subscriberPhotoSrc(subscriber, { preferThumb = true } = {}) {
  if (!subscriber) return null;
  if (preferThumb && subscriber.profile_photo_thumb) return subscriber.profile_photo_thumb;
  if (subscriber.profile_photo) return subscriber.profile_photo;
  return null;
}

export default function SubscriberAvatar({
  subscriber,
  size = 40,
  className = "",
  title,
}) {
  const src = subscriberPhotoSrc(subscriber);
  const dim = typeof size === "number" ? `${size}px` : size;
  const style = { width: dim, height: dim };

  if (src) {
    return (
      <img
        src={src}
        alt=""
        title={title}
        className={`rounded-full object-cover shrink-0 bg-white/5 ${className}`}
        style={style}
      />
    );
  }

  if (subscriber?.has_profile_photo) {
    return (
      <div
        title={title || "Foto en perfil"}
        className={`rounded-full grid place-items-center bg-white/5 shrink-0 ${className}`}
        style={style}
      >
        <User size={Math.max(12, Math.round((typeof size === "number" ? size : 40) * 0.4))} className="text-[#E63946]/80" />
      </div>
    );
  }

  return (
    <div
      title={title}
      className={`rounded-full grid place-items-center bg-white/5 shrink-0 ${className}`}
      style={style}
    >
      <User size={Math.max(12, Math.round((typeof size === "number" ? size : 40) * 0.4))} className="text-white/40" />
    </div>
  );
}
